import TestPageActionTypes from './testPage.types';

export const startAttempt = ({ courseId, elementId }) => ({
	type: TestPageActionTypes.START_ATTEMPT.PENDING,
	payload: { courseId, elementId },
});

export const fetchAttempt = () => ({
	type: TestPageActionTypes.FETCH_ATTEMPT.PENDING,
});

export const sendFeedback = (checkedValue) => ({
	type: TestPageActionTypes.SUBMIT_FEEDBACK.PENDING,
	payload: checkedValue,
});

export const sendAnswer = (postData) => ({
	type: TestPageActionTypes.SUBMIT_ANSWER.PENDING,
	payload: postData,
});

export const toggleSubmitActive = (val) => ({
	type: TestPageActionTypes.TOGGLE_SUBMIT_ACTIVE,
	payload: val,
});

export const setPrevVideoId = (val) => ({
	type: TestPageActionTypes.SET_PREV_VIDEO_ID,
	payload: val,
});

export const toggleFeedback = () => ({
	type: TestPageActionTypes.TOGGLE_FEEDBACK,
});

export const resetAttemptValues = () => ({
	type: TestPageActionTypes.SET_INITIAL_TEST_DETAILS,
});

export const setResetCounter = (val) => ({
	type: TestPageActionTypes.UPDATE_RESET_COUNTER,
	payload: val,
});

export const toggleMicPermission = (val) => ({
	type: TestPageActionTypes.TOGGLE_MIC_PERMISSION,
	payload: val,
});

export const checkVideo = () => ({
	type: TestPageActionTypes.CHECK_VIDEO.PENDING,
});

export const resetTestData = () => ({
	type: TestPageActionTypes.RESET_TEST_DATA,
});

export const setShowReview = (val) => ({
	type: TestPageActionTypes.SET_SHOW_REVIEW,
	payload: val,
});
export const setShowThankModal = (val) => ({
	type: TestPageActionTypes.SET_SHOW_THANK_YOU,
	payload: val,
});
